export const dataflowLexer = require('./grammar/DataflowLexer.js');
export const dataflowParser = require('./grammar/DataflowParser.js');
export const dataflowLexerWithAnnotation = require('./grammar-with-annotation/DataflowLexer.js');
export const dataflowParserWithAnnotation = require('./grammar-with-annotation/DataflowParser.js');
